import type { BonoContent } from '../types/content';

// The 5 bonos included with Maestro en Pista.
export const bonos: BonoContent[] = [
  {
    number: '01',
    label: 'BONO 01',
    title: 'FICHAS DE PISTA',
    tag: 'FICHA',
    oneLiner: '25 fichas para consultar el objetivo de la sesión antes de entrar a pista.',
    bullets: ['25 fichas listas para consultar', 'Objetivo y ejercicio en una página', 'Pensadas para leer en 30 segundos'],
    value: '15€'
  },
  {
    number: '02',
    label: 'BONO 02',
    title: 'RADAR DEL ALUMNO',
    tag: 'PLANTILLA',
    oneLiner: 'Diagnóstico express en 7 minutos para saber por dónde empezar con cada alumno.',
    bullets: ['Diagnóstico en 7 minutos', 'Detecta prioridades por alumno', 'Sin suposiciones, con datos'],
    value: '13€'
  },
  {
    number: '03',
    label: 'BONO 03',
    title: 'SEMÁFORO DE CORRECCIONES RÁPIDAS',
    tag: 'GUÍA RÁPIDA',
    oneLiner: '50 errores comunes con indicaciones concretas para corregirlos en pista.',
    bullets: ['50 errores comunes', 'Indicación concreta para cada uno', 'Corrige sin discursos largos'],
    value: '15€'
  },
  {
    number: '04',
    label: 'BONO 04',
    title: 'PLANIFICADOR 30 DÍAS',
    tag: 'PLANIFICADOR',
    oneLiner: 'Tu hoja de ruta para implantar el sistema poco a poco durante el primer mes.',
    bullets: ['Hoja de ruta semana a semana', 'Implementación progresiva', 'Sin saturarte el primer mes'],
    value: '13€'
  },
  {
    number: '05',
    label: 'BONO 05',
    title: 'VUELTA A PISTA',
    tag: 'RECURSO DE PISTA',
    oneLiner: 'Guía orientativa para adaptar el entrenamiento ante molestias físicas o una vuelta progresiva.',
    bullets: ['Entrenamiento adaptado', 'Para molestias o pausas', 'Orientativo, no médico'],
    value: '9€',
    note: 'Material educativo: no sustituye la valoración de un profesional sanitario.'
  }
];
